import { autoinject } from "aurelia-framework";
import { StorageService } from "./storage";
import { EventAggregator } from "aurelia-event-aggregator";
import { BindingSignaler } from "aurelia-templating-resources";
import { Config } from "../config";

@autoinject
export class LanguageService {
	private readonly storageKeyName = 'lang';
	private _defaultLang: string;
	private _currentLang: string;

	constructor(private _storage: StorageService, private _ea: EventAggregator, private _signaler: BindingSignaler) {
		// Default language is retrieved from config variable or, if not, it's 'en'
		this._defaultLang = Config.defaultLang || 'en';
		this._currentLang = this._storage.getData(this.storageKeyName, this._defaultLang);
		this.CurrentLang = this._currentLang; // to force change notifications
	}

	get DefaultLang(): string {
		return this._defaultLang;
	}

	set DefaultLang(lang: string) {
		this._defaultLang = lang;
	}

	get CurrentLang(): string {
		return this._currentLang;
	}

	set CurrentLang(lang: string) {
		this._storage.setData(this.storageKeyName, lang);
		this._currentLang = lang;
		this._ea.publish(Config.eventLangChanged, this._currentLang);
		this._signaler.signal(Config.eventLangChanged)
	}
}
